module.exports = __webpack_public_path__ + "img/dashboard2.6a3309c0.png";